export const CURRENCY_SYMBOL_MAP = {
  CHF: 'CHF',
  EUR: '€',
  GBP: '£',
  USD: '$',
}

export const CURRENCY_DEFAULT = 'EUR'

export const CURRENCY_FORMAT_OPTIONS = {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
}
